import { render, staticRenderFns } from "./TracksArtistsEditPanel.vue?vue&type=template&id=fa5b359c"
import script from "./TracksArtistsEditPanel.vue?vue&type=script&lang=js"
export * from "./TracksArtistsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./TracksArtistsEditPanel.vue?vue&type=style&index=0&id=fa5b359c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports